module.exports = __webpack_public_path__ + "static/media/lock.853df39a.svg";